import { ref } from "vue";
import { defineStore } from "pinia";
import { getConnectedCustomersStatus } from "@/utils/legacyMigrationApi";

export const useLegacyMigrationStore = defineStore("legacyMigration", () => {
  const accountsNeedingMigration = ref<number>(0);
  const totalConnectedAccounts = ref<number>(0);

  const resetState = (): void => {
    accountsNeedingMigration.value = 0;
    totalConnectedAccounts.value = 0;
  };

  const fetchLegacyMigrationStatus = async ({
    uuid,
  }: {
    uuid: string;
  }): Promise<void> => {
    if (!uuid) {
      throw new Error("Organisation ID is not provided");
    }

    const data = await getConnectedCustomersStatus(uuid);

    accountsNeedingMigration.value = data.old ?? 0;
    totalConnectedAccounts.value = data.total ?? 0;
  };

  return {
    accountsNeedingMigration,
    totalConnectedAccounts,
    resetState,
    fetchLegacyMigrationStatus,
  };
});
